import { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import styles from "./BitanicaIframePop.module.scss";

// img
import loader from "../../../assets/images/loading.gif";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserProfile,
  cancelOrderBitanicaPay,
} from "../../../lib/store/actions";
import { useGameContext } from "../../../context/GameContext";
import styled from "styled-components";
import { showToast } from "../../../helper/common";
import { socket } from "../../../utils/socket";

const BitanicaIframePop = ({
  bitanicaIframe,
  setBitanicaIframe,
  iframeData,
  setShowCancelOrderConfirmation,
  cancelOrderLoading,
}) => {
  const dispatch = useDispatch();
  const { user: userData } = useSelector(({ Auth }) => Auth);
  const { setGameEnergyLeft, setBtncBalance } = useGameContext();
  const [loading, setLoading] = useState(false);
  const [purchaseStatus, setPurchaseStatus] = useState(false);

    useEffect(() => {
    if (bitanicaIframe) {
      document.body.style.overflow = "hidden";
      document.body.classList.add("modal-open");
    } else {
      document.body.style.overflow = "auto";
      document.body.classList.remove("modal-open");
    }

    return () => {
      document.body.style.overflow = "auto";
      document.body.classList.remove("modal-open");

    };
  }, [bitanicaIframe]);

  // const handledHide = async () => {
  //   try {
  //     setLoading(true);

  //     if (userData?._id) {
  //       const cancelBody = {
  //         orderId: iframeData?.order_id,
  //       };

  //       const result = await dispatch(
  //         cancelOrderBitanicaPay({
  //           data: cancelBody,
  //         }),
  //       );

  //       if (cancelOrderBitanicaPay.fulfilled.match(result)) {
  //         const bodyParams = {
  //           _id: userData._id,
  //         };

  //         dispatch(
  //           getUserProfile({
  //             data: bodyParams,
  //             callBack: (err, res) => {
  //               if (!err && res?.status === "success") {
  //                 setGameEnergyLeft(res?.data?.energyBalance || 0);
  //                 setBtncBalance(res?.data?.btncBalance || 0);
  //               }
  //             },
  //           }),
  //         );

  //         setBitanicaIframe(false);
  //       }
  //     } else {
  //       setBitanicaIframe(false);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const getEnergyPurchaseHistoryStatus = async (order_id) => {
    return new Promise((resolve, reject) => {
      if (!socket?.connected) {
        reject(new Error("Socket not connected"));
        return;
      }

      const timeout = setTimeout(() => {
        reject(new Error("Socket timeout"));
      }, 10000);

      socket.emit("energyPurchaseHistoryStatus", { order_id }, (response) => {
        clearTimeout(timeout);

        if (response?.status) {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  };

  useEffect(() => {
    if (!iframeData?.order_id) return;

    let interval;

    const fetchStatus = async () => {
      try {
        const res = await getEnergyPurchaseHistoryStatus(iframeData?.order_id);

        setPurchaseStatus(res);

        if (res?.paymentStatus === "success") {
          clearInterval(interval);

          const bodyParams = {
            _id: userData._id,
          };

          dispatch(
            getUserProfile({
              data: bodyParams,
              callBack: (err, response) => {
                if (!err && response?.status === "success") {
                  setGameEnergyLeft(response?.data?.energyBalance || 0);
                  setBtncBalance(response?.data?.btncBalance || 0);
                }
              },
            }),
          );

          setTimeout(() => {
            setBitanicaIframe(false);
            showToast("Energy Purchased Successfully!", "success");
          }, 10000);
        }

        if (res?.paymentStatus === "expired") {
          clearInterval(interval);

          showToast("Order expired!", "error");
          setBitanicaIframe(false);
        }
      } catch (err) {
        console.error("Socket Error:", err);
      }
    };

    fetchStatus();

    interval = setInterval(fetchStatus, 3000);

    return () => {
      clearInterval(interval);
    };
  }, [iframeData?.order_id]);

  const handledHide = () => {
    setBitanicaIframe(!bitanicaIframe);
  };

  // useEffect(() => {
  //   const handleMessage = (event) => {
  //     if (event.data?.type === "BP-transaction-success") {
  //       const bodyParams = {
  //         _id: userData._id,
  //       };
  //       dispatch(
  //         getUserProfile({
  //           data: bodyParams,
  //           callBack: (err, res) => {
  //             if (!err && res?.status === "success") {
  //               setGameEnergyLeft(res?.data?.energyBalance || 0);
  //               setBtncBalance(res?.data?.btncBalance || 0);
  //             }
  //           },
  //         }),
  //       );
  //       showToast("Energy Purchased Successfully!", "success");
  //       setBitanicaIframe(false);
  //     }

  //     if (event.data === "Try Again") {
  //       setBitanicaIframe(false);
  //     }
  //   };

  //   window.addEventListener("message", handleMessage);

  //   return () => {
  //     window.removeEventListener("message", handleMessage);
  //   };
  // }, []);
  return (
    <>
      <Modal
        show={bitanicaIframe}
        onHide={handledHide}
        backdrop="static"
        centered
        scrollable="true"
        className={`${styles.buyPop} bottomPop`}
        keyboard={false}
      >
        <div className="modalWrpper">
          <Modal.Body className="p-0 position-relative">
            {cancelOrderLoading && (
              <div
                className="h-100 w-100 position-absolute d-flex align-items-center justify-content-center"
                style={{
                  borderRadius: 20,
                  background: "#00000080",
                  zIndex: 999,
                }}
              >
                <img
                  src={loader}
                  alt=""
                  className="img-fluid"
                  style={{ height: 50 }}
                />
              </div>
            )}
            <Button
              onClick={() => setShowCancelOrderConfirmation(true)}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 15, right: 15 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>
            <iframe
              src={iframeData?.iframe_url}
              width="600"
              className="w-100 "
              height="500"
              style={{ border: " none", minHeight: "90vh" }}
              title="Bitanica pay"
            ></iframe>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default BitanicaIframePop;
